import styled from 'styled-components';

const WrappedText = styled.span`
  overflow-wrap: anywhere;
`;

export default WrappedText;
